module.exports = __webpack_public_path__ + "static/media/hexagon-dark+text.33e10256.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/hexagon-dark+text.svg
// module id = 320
// module chunks = 1